import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

const SUPPORT_PHONE = '551150285000';

@Component({
  selector: 'app-invoice-support-banner',
  templateUrl: './invoice-support-banner.component.html',
  styleUrls: ['./invoice-support-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InvoiceSupportBannerComponent {
  @Input({ required: true }) invoiceId!: number | string;

  get whatsAppUrl(): string {
    const text = encodeURIComponent(
      `Preciso de ajuda com a Nota Fiscal da Venda ${this.invoiceId}`
    );
    return `https://wa.me/${SUPPORT_PHONE}?text=${text}`;
  }
}
